import { render, staticRenderFns } from "./SmagriaButton.vue?vue&type=template&id=f3b045cc&scoped=true"
import script from "./SmagriaButton.vue?vue&type=script&lang=js"
export * from "./SmagriaButton.vue?vue&type=script&lang=js"
import style0 from "./SmagriaButton.vue?vue&type=style&index=0&id=f3b045cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b045cc",
  null
  
)

export default component.exports